enum ChecklistFieldNames {
  DetailsTitle = 'detailsTitle',
  Name = 'name',
  Description = 'description',
  OptionsTitle = 'optionsTitle',
  Options = 'options',
  OptionValue = 'value',
  OptionValues = 'values',
}

export default ChecklistFieldNames;
